import { Modal, Table } from "react-bootstrap";
import { callQuery, Order, ORDERS_BY_CSN } from '../../amplify/api-gateway/query';
import { PatientVisit } from "../../amplify/api-gateway/search-patients";

import { useEffect, useState } from "react";
import './Meds.css';

/**
 * Modal showing orders information
 */
export const OrdersModal = (props: { 
    showModal: boolean,
    setShowModal: any,
    patientVisit: PatientVisit,
    addAnnotationToPlots: any,
}) => {
    const [orders, setOrders] = useState<any>([]);

    useEffect(() => {
        if (props.showModal) {
            callQuery({
                operation: ORDERS_BY_CSN,
                csn: props.patientVisit.csn,
            })
            .then((meds: Order[]) => {
                setOrders(meds);
            });
        }
    }, [props.showModal]);

    return (
        <Modal show={props.showModal} dialogClassName="modal-90w" onHide={() => props.setShowModal(false)}>
            <Modal.Header closeButton>
                <Modal.Title>Orders</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Table>
                    <thead>
                        <tr>
                            <th>Order Date</th>
                            <th>Start Date</th>
                            <th>Medication Name</th>
                        </tr>
                    </thead>
                    <tbody>
                        {orders.map((order: Order) => (
                            <tr key={order.order_item_id}>
                                <td>
                                    {order.order_time ? new Date(order.order_time).toLocaleString() : ""}
                                </td>
                                <td>
                                    {order.order_type}
                                </td>
                                <td>
                                    {order.order_item_id}
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </Table>
            </Modal.Body>
        </Modal>
    );
};
